export const ERROR_INVALID_FORMAT = 'Field amount should be a number with 2 digits after floating point';
export const ERROR_TO_LONG = 'Content length should be less than 255 characters';
